import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { CiStar } from "react-icons/ci";
import '../../CustomAssets/Css/Components/TestimonialSlider.css';
import axios from 'axios';
import API_BASE_URL from "../../config.jsx";

export default function TestimonialSlider() {
  const [testimonials, setTestimonials] = useState([]);

  const settings = {
    dots: true,              
    infinite: true,          
    speed: 1000,             
    autoplay: true,          
    autoplaySpeed: 5000,     
    slidesToShow: 3,         
    slidesToScroll: 1,       
    pauseOnHover: true,      
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  };


  const renderStars = (rating) => {
    let stars = [];
    let fullStars = Math.floor(rating); 
    let halfStars = Math.round(rating - fullStars); 

    for (let i = 0; i < fullStars; i++) {
      stars.push(<CiStar className="review_star filled" key={`filled-${i}`} />);
    }

    if (halfStars === 1) {
      stars.push(<CiStar className="review_star half" key="half" />);
    }

    let emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<CiStar className="review_star" key={`empty-${i}`} />);
    }

    return stars;
  };

  const fetchReviw = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}review/all`);
      setTestimonials(response.data.data);
    } catch (error) {
      console.error('Failed to fetch client lead:', error.message);
    } 
  };

  useEffect(() => {
    fetchReviw();
  }, []);

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {testimonials.map((review) => (
          <div key={review.review_id}>
            <div className="review_card">
              <div className="star_review mb-3">
                {renderStars(review.rating)}
              </div>
              <p className="review_text">{review.review_text}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
